import CountryCard from '@molecules/CountryCard';
import type { ReactElement } from 'react';

import { CardWrapper, ListTitle, ListWrapper } from './TagsListPageView.styled';
import type { TagsListPageViewProps } from './TagsListPageView.types';

export const TagsListPageView = ({
  categoryList,
}: TagsListPageViewProps): ReactElement => (
  <>
    <ListTitle>✈️ Wszystkie kierunki</ListTitle>
    <ListWrapper>
      {categoryList.map(category => {
        if (category.title.includes('Poradnik')) {
          return (
            <CardWrapper key={category.title} promoted>
              <CountryCard {...category} promoted buttonText="Zobacz" />
            </CardWrapper>
          );
        }

        return (
          <CardWrapper key={category.title}>
            <CountryCard {...category} />
          </CardWrapper>
        );
      })}
    </ListWrapper>
  </>
);
